import useCommonBlogQuery from "@repo/shopify/queries/useBlogQuery";

import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

export default function useBlog() {
  const { lang } = useLanguage();
  const { openToast } = useLayoutStore();

  return useCommonBlogQuery({
    lang,
    openToast,
  });
}
